import { Component, inject, input, signal } from '@angular/core';
import { ContactDetails } from 'src/app/models/contact.model';
import { ContactService } from 'src/app/services/contact/contact.service';
import { CoreService } from 'src/app/services/core/core.service';

@Component({
  selector: 'app-contact-details-card',
  templateUrl: './contact-details-card.component.html',
  styleUrls: ['./contact-details-card.component.scss'],
  standalone: false,
})
export class ContactDetailsCardComponent {
  /* Contact information used to render details inside the card */
  contactDetails = input<ContactDetails>();

  /* Indicates whether the app is running inside a mobile container */
  isMobileApp = signal<boolean>(false);

  private readonly coreService = inject(CoreService);
  private readonly contactService = inject(ContactService);

  /* Ionic lifecycle hook executed when the view is about to enter */
  ionViewWillEnter(): void {
    this.isMobileApp.set(this.coreService.isMobileApp);
  }

  /* Initiates a phone call to the provided number */
  callHolman(number: number | undefined): void {
    if (number) {
      window.open(`tel:${number}`, '_system');
    }
  }

  /* Opens the default mail client for the provided email address */
  openMail(email: string | undefined): void {
    if (email) {
      globalThis.location.href = `mailto:${email}`;
    }
  }
}
